import { useRouter } from 'next/router'

import React from 'react'

import en from '../locales/en.json'
import es from '../locales/es.json'
import de from '../locales/de.json'
import pt from '../locales/pt.json'
import fr from '../locales/fr.json'
import it from '../locales/it.json'

const translations = {
  en,
  es,
  de,
  pt,
  fr,
  it,
}

export function useTranslation() {
  const { locale } = useRouter()

  const t = (key: unknown) => {
    if (typeof key !== 'string' && !React.isValidElement(key)) return ''

    return translations[locale]?.[key] || translations.en?.[key as string] || key
  }

  const replacePlaceholders = (text: string, variables: Record<string, any>) => {
    if (!text || typeof text !== 'string') {
      return text
    }
    return text.replace(/{([^}]+)}/g, (match, key) => {
      return key in variables ? variables[key] : match
    })
  }

  const replacePlaceholdersWithElements = (text: string, variables: Record<string, any>) => {
    if (!text || typeof text !== 'string') return ''

    const parts = text.split(/({[^}]+})/g)
    const vars = variables || {}

    return parts.map((part) => {
      if (part.startsWith("{") && part.endsWith("}")) {
        const key = part.slice(1, -1)
        return vars?.[key] ?? part
      }
      return part
    })
  }

  return { t, locale, replacePlaceholders, replacePlaceholdersWithElements }
}
